<div *ngIf="example"
     class="item-box {{ select ? 'on' : '' }}"
     [attr.aria-current]="select ? 'true' : null"
     role="button">

  <div class="item-head-box">
    <app-example-disp class="example-text"
                      [exampleSJ]="exampleSJ"
                      [compact]="!select && !showSeungjo"></app-example-disp>

    <div class="item-option-box">
      <app-example-play-btn [example]="example"></app-example-play-btn>
    </div>
  </div>

  <div *ngIf="example.word1 && !select"
       class="detail-info-box">
    <div class="info-item-box">
      <div class="word-box">
        <div class="subject">단어</div>
        <div class="con">
          <div class="word-list">
            <app-link-content class="txt-box gray"
                              [content]="example.word1.word1 | rmSlash | resize">
            </app-link-content>
            <app-link-content *ngIf="example.word2"
                              class="txt-box gray"
                              [content]="example.word2.word1 | rmSlash | resize">
            </app-link-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
